import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ReturnContainersService } from 'src/app/services/return-containers.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import {
  ReturnDetails,
  ContainersList,
  ReturnDetailsRequest,
  ReturnList,
  ContainerPostBody,
} from 'src/app/models/return-container-reference';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RequestApiService } from 'src/app/services/domain_code/request-api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ContainerslistforreturnComponent } from '../containerslistforreturn/containerslistforreturn.component';
import { WarningBoxComponent } from '../../dialog-box/warning-box/warning-box.component';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { ApiRoutes } from 'src/app/services/apiroutes';

@Component({
  selector: 'logzy-return-containers',
  templateUrl: './return-containers.component.html',
  styleUrls: ['./return-containers.component.scss'],
})
export class ReturnContainersComponent implements OnInit {
  @Input() request_id: string = '';

  returnForm!: FormGroup;
  firstReturn: boolean = true;
  showDropoff: boolean = true;
  billuLoader: boolean = true;
  billuLoader1: boolean = true;
  loading: boolean = true;
  update: boolean = false;
  // part1: string = 'No';
  // part2: string = 'Returns';
  // part3: string = 'yet';
  part1: string = 'Just';
  part2: string = 'Checking';
  part3: string = 'data';
  part11: string = 'Just';
  part12: string = 'Checking';
  part13: string = 'data';
  createReturn: boolean = false;
  selectedIndex: number;
  PickupContainer: boolean = false;
  containerDetails: ReturnDetails[];
  containersList: ContainersList[];
  requirement: any;
  returnDetailsRequest: ReturnDetailsRequest;
  returnList: ReturnList[];
  cardLoader: boolean = true;

  displayedColumns: string[] = [
    'container_number',
    'container_size_type',
    'ownership',
    'pickup_date',
    'pickup_depot',
    'return_reference_no',
    'dropoff_date',
    'dropoff_depot',
    // 'user_remark',
  ];

  dataSource = new MatTableDataSource<ReturnDetails>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  errorObj: any = {};

  currentDate = new Date();

  selectedDepot: string = '';

  pageLength = 0;
  submitted = false;
  pageSize = 10;
  pageIndex = 0;

  cardValue: any = {
    options: [],
  };

  selectedContainers: string[] = [];

  showContainersList: boolean = false;
  returnId: string = '';

  dropDate: string = null;
  remarks: string = null;
  port: string = null;


  data: ContainerPostBody;

  transactionType: string = '';
  requestType: string = '';
  disableReturnButton: boolean = false;
  isCustomer: boolean;
  port_url = ApiRoutes.DepotMaster;
  @Output() navigatePickUp = new EventEmitter<any>();

  @ViewChild(ContainerslistforreturnComponent) containersListComponent!: ContainerslistforreturnComponent;

  constructor(
    private returnContainerService: ReturnContainersService,
    private _liveAnnouncer: LiveAnnouncer,
    private snackBar: MatSnackBar,
    public requestService: RequestApiService,
    private route: ActivatedRoute,
    private authService: AuthService,
    private dialog: MatDialog,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.isCustomer = this.authService.isCustomer();
    this.returnForm = new FormGroup({
      containers: new FormControl('', [Validators.required]),
      dropDate: new FormControl('', [Validators.required]),
      remarks: new FormControl(''),
    });

    this.route.queryParams.subscribe(params => {
      if ('type' in params) {
        this.transactionType = params['type'];
      }

      if ('rtype' in params) {
        this.requestType = params['rtype'];
      }
    });

    this.getContainerDetails();
    this.getReturnDetailsRequest()
  }

  getContainerDetails() {
    this.returnContainerService
      .getAllContainerDetails(this.request_id)
      .subscribe((res) => {
        this.containerDetails = res;
        this.dataSource = new MatTableDataSource<ReturnDetails>(
          this.containerDetails
        );
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.pageLength = res.length;

        if (this.pageLength > 0) {
          console.log(this.pageLength > 0, 'this.pageLength > 0');
          this.billuLoader = false;
          this.loading = false;
          this.update = false;
        }
        if (this.pageLength === 0) {
          console.log(this.pageLength === 0, 'this.pageLength === 0');
          this.part1 = 'No';
          this.part2 = 'Returns';
          this.part3 = 'yet';
          this.loading = false;
          this.update = false;
        }
      });
  }

  backtoList() {
    this.showContainersList = false;
    this.PickupContainer = false;
    this.firstReturn = true;
    this.showDropoff = true;
  }

  getReturnDetailsRequest() {
    this.returnContainerService
      .getReturnDetailsRequest(this.request_id)
      .subscribe((res) => {
        this.returnDetailsRequest = res;
        this.returnList = this.returnDetailsRequest.return_list;
        this.setBillu(this.returnList.length)
      });
  }

  setBillu(val) {
    if (val > 0) {
      console.log("length of card is ", val);
      this.billuLoader1 = false;
    } else {
      this.createReturn = true;
      this.part11 = "Create"
      this.part12 = "Return"
      this.part13 = "Reference"
      console.log("length of card is ", val);
    }
  }

  setMinDate(row) {
    let minDate = new Date();
    return minDate;
  }

  applyFilter(event: Event) {
    // this.pageIndex = 0;
    this.update = true;
    let filterValue = (event.target as HTMLInputElement).value;
    filterValue = filterValue.trim().toLowerCase();
    this.dataSource.filterPredicate = (
      data: ReturnDetails,
      filter: string
    ) => {
      // console.log(
      //     'this.dataSource.filterPredicate ---------------->',
      //     data
      // );
      // console.log(data.return_details.return_details);
      if (data.return_details.return_details == null) {
        return (
          data.container.container_number
            .toLowerCase()
            .includes(filter) ||
          data.pickup_depot.display_name
            .toLowerCase()
            .includes(filterValue)
        );
      } else {
        return (
          data.container.container_number
            .toLowerCase()
            .includes(filter) ||
          data.return_details.return_reference_no
            .toLowerCase()
            .includes(filter) ||
          data.pickup_depot.display_name
            .toLowerCase()
            .includes(filterValue) ||
          data.return_details.dropoff_depot.display_name
            .toLowerCase()
            .includes(filterValue)
        );
      }
    };

    // console.log(filterValue.trim().toLowerCase());
    this.dataSource.filter = filterValue;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
    setTimeout(() => {
      this.update = false;
    }, 500);
  }

  AddDropoff() {
    this.PickupContainer = true;
    this.firstReturn = false;

    this.showDropoff = false;
    this.getReturnDetailsRequest();
    setTimeout(() => {
      document.getElementById('returnContainer').scrollIntoView({
        behavior: 'smooth',
        block: 'start',
        inline: 'start',
      });
    }, 200);
  }

  sortData(sortState: Sort) {
    this.update = true;
    if (sortState.direction) {
      this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`);
      this.update = false;
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
      this.update = false;
    }
  }

  // onSubmit() {
  //     this.submitted = true;
  //     if (this.selectedContainers.length == 0) {
  //         this.returnForm.controls['containers'].markAsTouched;
  //         this.returnForm.controls['containers'].invalid;
  //     } else {
  //         this.returnForm.controls['containers'].patchValue(
  //             this.selectedContainers
  //         );
  //         this.returnForm.controls['containers'].valid;
  //     }
  //     this.returnForm.updateValueAndValidity();

  //     if (!this.returnForm.valid) {
  //         this.snackBar.open(
  //             'Please select containers and drop-off date',
  //             'Close',
  //             {
  //                 verticalPosition: 'top',
  //                 duration: 3000,
  //             }
  //         );
  //         return false;
  //     } else {
  //         this.returnContainerService
  //             .saveReturnDetails(this.returnForm.value, this.returnId)
  //             .subscribe({
  //                 next: (res) => {
  //                     this.getContainerDetails();
  //                     this.getReturnDetailsRequest();
  //                     this.showContainersList = false;
  //                     this.snackBar.open('Return Successfully!', 'Close', {
  //                         verticalPosition: 'top',
  //                         duration: 2000,
  //                     });
  //                 },
  //                 error: (error) => {
  //                     console.log(error);
  //                     return this.catchError(error);
  //                 },
  //             });
  //     }
  // }

  getContainersList() {
    this.selectedContainers = [];
    this.containersListComponent.selection.selected.forEach(container => {
      // console.log(container);
      if (container.dropoff_date == null)
        this.selectedContainers.push(container.container.id)
    });
    // console.log('selected containers for dropoff', this.selectedContainers);
  }

  openWarning(label: string, description, action1: string, action2?: string) {
    const dialogRef = this.dialog.open(WarningBoxComponent, {
      panelClass: 'dialog-container-custom',
      disableClose: true,
      data: { subTitle: label, parent: this, description: description, label1: action1, label2: action2 }
    });
  }

  postReturnContainerDropOff() {
    this.getContainersList();
    if (this.selectedContainers.length == 0) {
      this.openWarning('Please select at least one container which is yet not returned.', '', 'I Understand');
      return;
    }

    if (this.dropDate == null) {
      this.openWarning('Please select return date', '', 'I Understand');
      return;
    }

    if (this.selectedContainers.length != 0) {
      let containers: any[] = [], invalidContainers: any[] = [];
      if (this.requestType == 'lease') {
        this.requestService.getCommercials(this.request_id, this.requestType).subscribe(res => {
          this.containersListComponent.selection.selected.forEach(container => {
            if (container.dropoff_date == null)
              containers.push(container);
          });

          let minRentalPeriod = res.quote_items.filter((item: any) => item.requirement == this.requirement.id).map((item1: any) => item1.minimum_rental_period_days).at(0);

          containers.map((container: any) => {
            this.containerDetails.map((contDetail: any) => {
              if (contDetail.container.id == container.container.id) {
                const selectedDate = new Date(contDetail.pickup_date);
                const calculatedDate = new Date(selectedDate.getTime());
                const finalDate = calculatedDate.setDate(calculatedDate.getDate() + minRentalPeriod);
                if (new Date(finalDate) > new Date(this.dropDate))
                  invalidContainers.push({
                    container: contDetail.container.container_number,
                    pickUpDate: contDetail.pickup_date,
                    minRentalPeriod: minRentalPeriod
                  });
              }
            });
          })

          if (invalidContainers.length != 0) {
            console.log(invalidContainers);

            const tableHtml = this.createHtmlTable(invalidContainers)

            const dialogRef = this.dialog.open(WarningBoxComponent, {
              panelClass: 'dialog-container-custom',
              disableClose: true,
              data: {
                subTitle: '', parent: this, description: 'The minimum rental period for the following' +
                  ' containers is less than the selected drop off date.' + tableHtml, label1: 'Cancel', label2: 'Ok'
              }
            });

            dialogRef.afterClosed().subscribe(item => {
              if (item) {
                console.log(this.selectedContainers);
                this.disableReturnButton = true;
                this.returnContainerService
                  .saveReturnDetails(
                    this.selectedContainers,
                    this.dropDate,
                    this.remarks,
                    this.returnId,
                    this.port
                  )
                  .subscribe({
                    next: (response) => {
                      this.getContainerDetails();
                      this.getReturnDetailsRequest();
                      this.showContainersList = false;
                      this.firstReturn = true;
                      this.PickupContainer = false;
                      this.showDropoff = true;
                      this.disableReturnButton = false;
                      this.snackBar.open('Containers Dropped-off Successfully!', 'Close', {
                        verticalPosition: 'top',
                        duration: 2000,
                      });
                      this.showContainersList = false;
                    },
                    error: (error) => {
                      this.disableReturnButton = false;
                      return this.catchError(error);
                    },
                  });
              }
              else {
                return;
              }
            })
          } else {
            console.log(this.selectedContainers);
            // console.log(this.dropDate);
            // console.log(this.remarks);
            this.disableReturnButton = true;
            this.returnContainerService
              .saveReturnDetails(
                this.selectedContainers,
                this.dropDate,
                this.remarks,
                this.returnId,
                this.port
              )
              .subscribe({
                next: (response) => {
                  this.getContainerDetails();
                  this.getReturnDetailsRequest();
                  this.showContainersList = false;
                  this.firstReturn = true;
                  this.PickupContainer = false;
                  this.showDropoff = true;
                  this.disableReturnButton = false;
                  this.snackBar.open('Containers Dropped-off Successfully!', 'Close', {
                    verticalPosition: 'top',
                    duration: 2000,
                  });
                  this.showContainersList = false;
                },
                error: (error) => {
                  this.disableReturnButton = false;
                  return this.catchError(error);
                },
              });
          }
        })
      } else {
        console.log(this.selectedContainers);
        // console.log(this.dropDate);
        // console.log(this.remarks);
        this.disableReturnButton = true;
        this.returnContainerService
          .saveReturnDetails(
            this.selectedContainers,
            this.dropDate,
            this.remarks,
            this.returnId,
            this.port
          )
          .subscribe({
            next: (response) => {
              this.getContainerDetails();
              this.getReturnDetailsRequest();
              this.showContainersList = false;
              this.firstReturn = true;
              this.PickupContainer = false;
              this.showDropoff = true;
              this.disableReturnButton = false;
              this.snackBar.open('Containers Dropped-off Successfully!', 'Close', {
                verticalPosition: 'top',
                duration: 2000,
              });
              this.showContainersList = false;
            },
            error: (error) => {
              this.disableReturnButton = false;
              return this.catchError(error);
            },
          });
      }
    }
  }

  createHtmlTable(data) {
    let tableHTML = `
    <div style="overflow-y: auto; height: 200px; border: 1px solid #ccc;">
        <table style="border-collapse: collapse; width: 100%; text-align: left;">
        <thead>
          <tr>
            <th>Container</th>
            <th>Pick Up Date</th>
            <th>Min Rental Period(Days)</th>
          </tr>
        </thead>
       <tbody>
  `;

    data.forEach(item => {
      tableHTML += `
      <tr>
        <td>${item.container}</td>
        <td>${new Date(item.pickUpDate).toLocaleDateString()}</td>
        <td>${item.minRentalPeriod}</td>
      </tr>
    `;
    });

    tableHTML += `
        </tbody>
       </table>
     </div>
  `;

    return tableHTML;
  }

  get myForm() {
    return this.returnForm.controls;
  }

  getSelectedContainers($event) {
    this.selectedContainers = $event;
  }
  selectRR:any;
  select(item, i) {
    this.selectRR = item;
    if (item.remaining_dropoff_quantity) {
      this.selectedIndex = i;
      this.showContainersList = true;
      this.returnId = item.id;
      this.containersList = item.containers;
      this.requirement = item.requirement;
      this.containersListComponent.selection.clear();
    }
    // this.getPortsByLocationId(item.depot?.id);
  }

  catchError(error) {
    if (error.status >= 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug('error object', this.errorObj);
      return error;
    } else if (error.status > 399 && error.status < 500) {
      this.errorObj = { ...error.error };
      console.log(error.status, error.statusText, error);
      console.debug('error object', this.errorObj);
      return error;
    }
  }

  navigatePickup() {
    this.router.navigateByUrl[''];
    this.navigatePickUp.emit('return_reference');
  }

  ports_url:any;
  getPortsByLocationId(id) {
      this.returnContainerService.getPortsByLocationId(id).subscribe({
          next: response => {
              this.ports_url = response.results;
          },
      })
  }
}
